import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
var Resizable = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Resizable, _React$Component);
  function Resizable(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.handleMouseMove = props.handleMouseMove;
    _this.handleMouseDown = _this.handleMouseDown.bind(_assertThisInitialized(_this));
    _this.handleMouseUp = _this.handleMouseUp.bind(_assertThisInitialized(_this));
    return _this;
  }
  var _proto = Resizable.prototype;
  _proto.handleMouseDown = function handleMouseDown() {
    document.addEventListener('mousemove', this.handleMouseMove, false);
    document.addEventListener('mouseup', this.handleMouseUp, false);
  };
  _proto.handleMouseUp = function handleMouseUp() {
    document.removeEventListener('mousemove', this.handleMouseMove, false);
    document.removeEventListener('mouseup', this.handleMouseUp, false);
  };
  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "resize-handle",
      onMouseDown: this.handleMouseDown,
      style: {
        left: this.props.left
      }
    }, "Resizable");
  };
  return Resizable;
}(React.Component);
export default Resizable;